<template>
  <l-marker v-if="positionVisible" :lat-lng="[gpsLat, gpsLong]">
    <l-icon
      :icon-size="[20,20]"
      :icon-anchor="[10,10]"
      class-name="custom-location-icon"
    >
      <div class="location-circle"></div>
    </l-icon>
  </l-marker>
</template>

<script>
import { LMarker, LIcon } from "@vue-leaflet/vue-leaflet";

export default {
  name: "Position",

  components: {
    LMarker,
    LIcon
  },

  data() {
    return {
      positionVisible: false,
      gpsLat: null,
      gpsLong: null,
      watchId: null,
      debugAusgabe: ""
    };
  },

  methods: {

    // Start GPS tracking
    setGPSPosition() {
      console.log("Versuche, GPS-Position zu erhalten...");

      if (!navigator.geolocation) {
        console.error("Geolocation wird von diesem Browser nicht unterstützt.");
        return;
      }

      this.watchId = navigator.geolocation.watchPosition(
        (position) => {

          if (position.coords.accuracy > 20 && this.positionVisible) {
            console.log("Position zu ungenau: " + position.coords.accuracy + " Meter");
            return; // zu ungenau
          }

          this.gpsLat = position.coords.latitude;
          this.gpsLong = position.coords.longitude;

          console.log("Aktuelle Koordinaten:", this.gpsLat, this.gpsLong);

          if (this.positionVisible === false) {
            this.$emit("positionUpdate", {
              lat: this.gpsLat,
              lng: this.gpsLong
            });
          }

          this.$emit("setPositionActive", true);
          this.positionVisible = true;
        },

        (error) => {
          console.error("Error getting geolocation:", error.message);
          this.$emit("setPositionActive", false);
          this.positionVisible = false;
        },

        {
          enableHighAccuracy: true,
          maximumAge: 1000,
          timeout: 5000
        }
      );
    },


    // Ask for location permission (Cordova / Android)
    askForGeoLocationPermission() {

      if (!window.cordova) {
        console.log("Cordova nicht erkannt – Browsermodus.");
        return;
      }

      const permissions = cordova.plugins.permissions;

      permissions.checkPermission(
        permissions.ACCESS_FINE_LOCATION,

        (status) => {

          if (!status.hasPermission) {

            permissions.requestPermission(
              permissions.ACCESS_FINE_LOCATION,

              () => {
                console.log("Geolocation permission granted");
                this.setGPSPosition();
              },

              () => {
                console.error("Geolocation permission denied");
              }
            );

          } else {

            console.log("Permission already granted");
            this.setGPSPosition();

          }
        },

        (error) => {
          console.error("Error checking permissions", error);
        }
      );
    }

  },


  created() {

    // Cordova environment
    if (window.cordova) {

      document.addEventListener("deviceready", () => {
        this.askForGeoLocationPermission();
      });

    }

    // Browser environment
    else {

      this.setGPSPosition();

    }

  },


  beforeUnmount() {

    // Stop GPS tracking when component is destroyed
    if (this.watchId !== null) {
      navigator.geolocation.clearWatch(this.watchId);
    }

  }

};
</script>

<style lang="scss">

/* Leaflet Standard Icon entfernen */
.custom-location-icon {
  background: transparent !important;
  border: none !important;
}

/* Standort-Kreis */
.location-circle {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background-color: rgb(255,255,255);
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* Innerer blauer Punkt */
.location-circle::before {
  content: '';
  width: 14px;
  height: 14px;
  border-radius: 50%;
  background-color: rgb(0,0,255);
  animation: pulse 2.5s infinite ease-in-out;
}

/* Pulsanimation */
@keyframes pulse {

  0%,100% {
    transform: scale(1);
  }

  50% {
    transform: scale(0.8);
  }

}

</style>